import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
// import dateFormat from "dateformat";
import {
  getLaundryOrders,
  getAllActiveServices
} from "../../network/ApiAxios";
import { redirectToLogout, parseWashingFeatures,zeroFill,numericSortFunc,getIsPickedFromLaundry} from "common/SharedFn";
import { Receipt } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const LaundryOrdersTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [filterBy, setFilterBy] = useState(0);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [ids, setIds] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  var columns = [];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessScanQrPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/scanQr");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const clearCurrentRecord = () => {
    setId();
  };

  const fetchOrders = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getLaundryOrders(startDate, endDate, filterBy);
      const responseServicesList = await getAllActiveServices();
      const { data } = response;
      if (data.result.isSuccess) {
        console.log("Orders: "+JSON.stringify(data.data));
        setServicesList(responseServicesList.data.data);
        setData(data.data.map((prop) => makeTableRow(prop,responseServicesList.data.data)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch orders "+ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
      if (endDate == null) {
        setEndDate(new Date());
      }
      if (startDate == null) {
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
      if (filterBy == null) {
        setFilterBy(0);
      }
      if (startDate != null && endDate != null  && filterBy != null) {
        fetchOrders();
      }
    
  }, [
    forceRefresh,
    startDate,
    endDate,
    filterBy,
  ]);


  const getOrderColumns = () =>{
    columns = [
      {
        dataField: "idForm",
        text: "ID",
        sort: true,
      },
      {
        dataField: "userIdForm",
        text: "User ID",
        sort: true,
      },
      // {
      //   dataField: "pickupTimeslot",
      //   text: "Customer Pickup DateTime",
      //   sort: true,
      //   csvExport: true,
      //   sortFunc: slotDateSortFunc,
      // },
      
    ];
      if(servicesList.length > 0 ){
        servicesList.sort(function(a,b) {
          var x = a.nameEn.toLowerCase();
          var y = b.nameEn.toLowerCase();
          return x < y ? -1 : x > y ? 1 : 0;
      });
      }
      for (var j = 0; j < servicesList.length; j++) {
        if(servicesList[j].isPerItem === 0){
        columns.push({ 
           dataField: servicesList[j].nameEn+"Q",
        text:  servicesList[j].nameEn.replaceAll("doobi ",""),
        sort: true,
        sortFunc: numericSortFunc});
        }
      }
      columns.push({
        dataField: "totalPerItem",
        text: "Per Item Count",
        sort: true,
        sortFunc: numericSortFunc
      },
      {
        dataField: "statusTextByStatus.textEn",
        text: "Status",
        sort: true,
      },
      {
        dataField: "isPickedFromLaundry",
        text: "Picked from Laundry",
        sort: true,
      },
      {
        dataField: "actions",
        text: "Actions",
        csvExport: false,
      },
    );
  }


  const makeTableRow = (info,services) => {
    info = parseWashingFeatures(info);
    // info.pickupDateText = dateFormat(new Date(info.pickupDate), "d-mmm-yyyy");

    //Reset List
    for (var j = 0; j < services.length; j++) {
      info[services[j].nameEn+"Q"]= 0;
    }
    // info.services = "";
    info.totalBags = 0;
    info.totalPerItem = 0;
    for (var i = 0; i < info.orderServicesById.length; i++) {
      if(info.orderServicesById[i].serviceByServiceId.isPerItem === 1){
        info.totalPerItem = info.totalPerItem + info.orderServicesById[i].quantity;
      }
      else{
        info.totalBags = info.totalBags + info.orderServicesById[i].quantity;
        for (j = 0; j < services.length; j++) {
          if(services[j].id === info.orderServicesById[i].serviceByServiceId.id){
            info[services[j].nameEn+"Q"] = info.orderServicesById[i].quantity;
            // console.log(services[j].nameEn+":"+JSON.stringify(info[services[j].nameEn+"Q"]));
            break;
          }
        }
      }
    }
    info.isPickedFromLaundry = getIsPickedFromLaundry(info) ? "Yes" : "No";
    return {
      ...info,
      idForm: (
        info.publicId
      ),
      userIdForm: (
        "C"+zeroFill(info.userId,5)
      ),
      pickupTimeslot:
        info.pickupDateText +
        " " +
        info.availabilitySlotByPickupTimeslot?.startTime +
        " - " +
        info.availabilitySlotByPickupTimeslot?.endTime,
      dropoffTimeslot:
        info.dropoffDateText +
        " " +
        info.availabilitySlotByDropoffTimeslot?.startTime +
        " - " +
        info.availabilitySlotByDropoffTimeslot?.endTime,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Details">
            <Button
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {
                accessOrderPage(info.id);
              }}
            >
              <Box component={Receipt} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {getOrderColumns()}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Orders</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <ToolkitProvider
                data={data}
                keyField="id"
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                    <Grid item xs={12} sm={6}>

                    <Tooltip
                          title="Scan QR"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                                clearCurrentRecord();
                                accessScanQrPage();
                            }}
                          >
                            <span>Scan QR</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label">Download</span>
                        </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    {/* <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Orders Selected
                        </div>
                      </Grid>
                    </Grid> */}
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      // selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>


        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default LaundryOrdersTable;
